"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icon = _interopRequireDefault(require("@mapbox/mr-ui/icon"));

var _levelIndicator = _interopRequireDefault(require("../level-indicator/level-indicator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Card = /*#__PURE__*/function (_React$Component) {
  _inherits(Card, _React$Component);

  var _super = _createSuper(Card);

  function Card() {
    _classCallCheck(this, Card);

    return _super.apply(this, arguments);
  }

  _createClass(Card, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          thumbnail = _this$props.thumbnail,
          level = _this$props.level,
          language = _this$props.language,
          description = _this$props.description,
          path = _this$props.path,
          title = _this$props.title;
      var renderedThumbnail = '';
      var renderedLevel = '';
      var renderedLanguage = '';

      if (thumbnail) {
        renderedThumbnail = /*#__PURE__*/_react.default.createElement("div", {
          className: "relative h120 mb6"
        }, thumbnail);
      }

      if (level) {
        renderedLevel = /*#__PURE__*/_react.default.createElement("div", {
          className: "inline-block mr18 txt-s txt-bold"
        }, /*#__PURE__*/_react.default.createElement(_levelIndicator.default, {
          level: level
        }));
      }

      if (language) {
        renderedLanguage = /*#__PURE__*/_react.default.createElement("div", {
          className: "inline-block color-gray txt-s txt-bold"
        }, /*#__PURE__*/_react.default.createElement(_icon.default, {
          name: "code",
          inline: true
        }), " ", language);
      }

      return /*#__PURE__*/_react.default.createElement("a", {
        className: "color-gray-dark transition color-blue-on-hover round clip inline-block w-full unprose pb18",
        href: path
      }, renderedThumbnail, /*#__PURE__*/_react.default.createElement("div", null, renderedLevel || renderedLanguage ? /*#__PURE__*/_react.default.createElement("div", {
        className: "mb6"
      }, renderedLevel, renderedLanguage) : '', /*#__PURE__*/_react.default.createElement("div", {
        className: "mb6"
      }, title), description && /*#__PURE__*/_react.default.createElement("div", {
        className: "color-gray color-gray-on-hover"
      }, description)));
    }
  }]);

  return Card;
}(_react.default.Component);

Card.propTypes = {
  title: _propTypes.default.string.isRequired,
  path: _propTypes.default.string.isRequired,
  description: _propTypes.default.string,
  thumbnail: _propTypes.default.node,
  level: _propTypes.default.node,
  language: _propTypes.default.string
};
var _default = Card;
exports.default = _default;